function initPage() {
  initGallerySwiper();
  initMainSwiper();
  initAccordion();
  initInfoDropdown();
  initPromocodeHandler();
  initMobileMenu();
  initHeroScrollHandler();
  initAnimatedNavDot();
  initAnchorSpyWithScrollTrigger();
  // initHeaderScroll(); // Disabled: header no longer sticky
  initSpeakersMenu();
  initSpeakersSlider();
  initCartItemsDragScroll();
  initQuickAddButtons();
  initLiteTermsModal();
  loadMore();
  openVideo();
  metrika();
  initBenefitsAnswerAnimation();
  initReviewsDecorsAnimation();
  initPartnersMarquee();
  initVariantSelector();
  initQuantityButtons();
  updateVariantsAvailability();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPage);
} else {
  initPage();
}

const LOCALE_SEGMENT_REGEX = /^[a-z]{2}(?:-[a-z]{2})?$/i;
const DESKTOP_SPEAKERS_TRANSITION_MS = 450;

function onViewportWidthChange(callback) {
  if (typeof callback !== "function") return;
  let lastWidth = window.innerWidth;

  window.addEventListener(
    "resize",
    () => {
      const nextWidth = window.innerWidth;
      if (nextWidth === lastWidth) return;
      lastWidth = nextWidth;
      callback();
    },
    { passive: true },
  );
}

function normalizePathname(pathname) {
  if (!pathname) return "/";

  let normalized = pathname.trim();
  if (normalized === "") return "/";
  if (!normalized.startsWith("/")) {
    normalized = `/${normalized}`;
  }
  normalized = normalized.replace(/\/+/g, "/");
  if (normalized.length > 1 && normalized.endsWith("/")) {
    normalized = normalized.replace(/\/+$/, "");
  }

  const segments = normalized.split("/").filter(Boolean);
  if (segments.length && LOCALE_SEGMENT_REGEX.test(segments[0])) {
    segments.shift();
    normalized = segments.length ? `/${segments.join("/")}` : "/";
  }

  return normalized || "/";
}

const PUBSUB_EVENTS =
  window.PUB_SUB_EVENTS ||
  (typeof PUB_SUB_EVENTS !== "undefined" ? PUB_SUB_EVENTS : null);

document.addEventListener("cart:updated", function (event) {
  setTimeout(() => {
    updateVariantsAvailability(event.detail || null);
  }, 500);
});

// Gallery Swiper with thumbnails
function initGallerySwiper() {
  const thumbContainer = document.querySelector("#thumb-swiper");
  const galleryContainer = document.querySelector("#gallery-swiper");

  if (!thumbContainer || !galleryContainer) return;

  const syncGalleryVideoPlayback = (swiperInstance) => {
    const allVideos = galleryContainer.querySelectorAll("video");
    allVideos.forEach((video) => {
      if (!video.paused) {
        video.pause();
      }
      video.currentTime = 0;
    });

    const activeSlide = swiperInstance?.slides?.[swiperInstance.activeIndex];
    const activeVideo = activeSlide?.querySelector("video");
    if (activeVideo) {
      activeVideo.play().catch(() => {});
    }
  };

  const galleryThumbs = new Swiper("#thumb-swiper", {
    slidesPerView: "auto",
    watchSlidesProgress: true,
    grabCursor: true,
    loop: true,
  });

  const galleryTop = new Swiper("#gallery-swiper", {
    slidesPerView: "auto",
    centeredSlides: true,
    navigation: {
      nextEl: "#thumb-arrow-next-slide",
      prevEl: "#thumb-arrow-prev-slide",
    },
    thumbs: {
      swiper: galleryThumbs,
    },
    loop: true,
    on: {
      init: function () {
        syncGalleryVideoPlayback(this);
      },
      slideChangeTransitionStart: function () {
        syncGalleryVideoPlayback(this);
      },
    },
  });
}

// Accordion for FAQ
function initAccordion() {
  const faqItems = document.querySelectorAll(".faq__item");

  faqItems.forEach((item) => {
    item.addEventListener("click", function () {
      const isActive = this.classList.contains("accordion-active");

      faqItems.forEach((otherItem) => {
        if (
          otherItem !== item &&
          otherItem.classList.contains("accordion-active")
        ) {
          otherItem.classList.remove("accordion-active");
          const otherBody = otherItem.querySelector(".faq__item-body");
          if (otherBody) {
            otherBody.style.height = "0px";
          }
        }
      });

      if (!isActive) {
        this.classList.add("accordion-active");
        const body = this.querySelector(".faq__item-body");
        if (body) {
          const textHeight = body.scrollHeight;
          body.style.height = `${textHeight}px`;
        }
      } else {
        this.classList.remove("accordion-active");
        const body = this.querySelector(".faq__item-body");
        if (body) {
          body.style.height = "0px";
        }
      }
    });
  });
}

// Info dropdown
function initInfoDropdown() {
  const infoTriggers = document.querySelectorAll(".info__dd");
  if (!infoTriggers.length) return;
  const collapseFrameByBody = new WeakMap();
  const expandedHeightByBody = new WeakMap();

  const updateBodyHeightCache = (ddBody) => {
    if (!ddBody) return 0;
    const targetHeight = ddBody.scrollHeight;
    expandedHeightByBody.set(ddBody, targetHeight);
    return targetHeight;
  };

  const getBodyTargetHeight = (ddBody) => {
    const cachedHeight = expandedHeightByBody.get(ddBody);
    if (typeof cachedHeight === "number" && cachedHeight > 0) {
      return cachedHeight;
    }
    return updateBodyHeightCache(ddBody);
  };

  const setDropdownState = (trigger, shouldOpen) => {
    const ddBody = trigger.querySelector(".dd__body-info");
    const arrow = trigger.querySelector(".locale__arrow");
    if (!ddBody) return;

    const pendingFrame = collapseFrameByBody.get(ddBody);
    if (pendingFrame) {
      cancelAnimationFrame(pendingFrame);
      collapseFrameByBody.delete(ddBody);
    }

    if (shouldOpen) {
      trigger.classList.add("is-open");
      ddBody.classList.add("active");
      arrow?.classList.add("active");
      ddBody.style.height = `${getBodyTargetHeight(ddBody)}px`;
      return;
    }

    ddBody.style.height = `${getBodyTargetHeight(ddBody)}px`;

    const frameId = requestAnimationFrame(() => {
      ddBody.style.height = "0px";
      collapseFrameByBody.delete(ddBody);
    });
    collapseFrameByBody.set(ddBody, frameId);

    trigger.classList.remove("is-open");
    ddBody.classList.remove("active");
    arrow?.classList.remove("active");
  };

  infoTriggers.forEach((trigger) => {
    const ddBody = trigger.querySelector(".dd__body-info");
    const arrow = trigger.querySelector(".locale__arrow");
    if (!ddBody) return;
    updateBodyHeightCache(ddBody);

    const isOpen =
      trigger.classList.contains("is-open") ||
      ddBody.classList.contains("active");
    trigger.classList.toggle("is-open", isOpen);
    ddBody.classList.toggle("active", isOpen);
    arrow?.classList.toggle("active", isOpen);
    ddBody.style.height = isOpen ? `${getBodyTargetHeight(ddBody)}px` : "0px";
  });

  infoTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function () {
      const ddBody = this.querySelector(".dd__body-info");
      const willOpen = ddBody ? !this.classList.contains("is-open") : false;

      infoTriggers.forEach((otherTrigger) => {
        if (otherTrigger === this) return;
        if (!otherTrigger.classList.contains("is-open")) return;
        setDropdownState(otherTrigger, false);
      });

      setDropdownState(this, willOpen);
    });
  });

  onViewportWidthChange(() => {
    infoTriggers.forEach((trigger) => {
      const ddBody = trigger.querySelector(".dd__body-info");
      if (!ddBody) return;
      const targetHeight = updateBodyHeightCache(ddBody);
      if (trigger.classList.contains("is-open")) {
        ddBody.style.height = `${targetHeight}px`;
      }
    });
  });

  window.addEventListener("load", () => {
    infoTriggers.forEach((trigger) => {
      const ddBody = trigger.querySelector(".dd__body-info");
      if (!ddBody) return;
      const targetHeight = updateBodyHeightCache(ddBody);
      if (trigger.classList.contains("is-open")) {
        ddBody.style.height = `${targetHeight}px`;
      }
    });
  });
}

// Mobile menu
function initMobileMenu() {
  const menuToggle = document.querySelector(".header__menu");

  if (!menuToggle) return;

  const setMobileMenuViewportHeight = () => {
    const viewportHeight = window.visualViewport
      ? Math.round(window.visualViewport.height)
      : window.innerHeight;

    document.documentElement.style.setProperty(
      "--mobile-menu-vh",
      `${viewportHeight}px`,
    );
  };

  const toggleMenu = () => {
    const root = document.documentElement;
    const menuOpen = document.querySelector(".menu__open");
    const menuClose = document.querySelector(".menu__close");
    const linksWrap = document.querySelector(".links__wrap");
    const headerBg = document.querySelector(".header__bg");
    const headerShell = document.querySelector(".header__shell");
    const speakersContainer = document.querySelector("[data-speakers]");
    const speakersTrigger = document.querySelector("[data-speakers-trigger]");
    const mobileSpeakers = document.querySelector("[data-speakers-mobile]");

    const isMenuOpen = menuOpen.style.display === "none";

    if (!isMenuOpen) {
      setMobileMenuViewportHeight();
    }

    menuOpen.style.display = isMenuOpen ? "block" : "none";
    menuClose.style.display = isMenuOpen ? "none" : "block";
    linksWrap.style.top = isMenuOpen ? "-100vh" : "0vh";
    document.body.style.overflow = isMenuOpen ? "visible" : "hidden";
    document.body.style.touchAction = isMenuOpen ? "" : "none";
    document.body.classList.toggle("mobile-menu-open", !isMenuOpen);
    root.classList.toggle("mobile-menu-open", !isMenuOpen);
    if (headerShell) {
      headerShell.style.overflow = isMenuOpen ? "" : "visible";
      headerShell.classList.toggle("menu-open", !isMenuOpen);
    }

    if (isMenuOpen) {
      document.dispatchEvent(
        new CustomEvent("speakers:close", { detail: { hideUp: true } }),
      );
      if (mobileSpeakers && !mobileSpeakers.hasAttribute("aria-hidden")) {
        mobileSpeakers.setAttribute("aria-hidden", "true");
      }
      linksWrap.classList.remove("speakers-mobile-open");
      speakersContainer?.classList.remove("is-open");
      speakersTrigger?.setAttribute("aria-expanded", "false");
      document.body.classList.remove("header-speakers-open");
    }

    if (headerBg) {
      if (isMenuOpen) {
        headerBg.style.display = "none";
        headerBg.style.opacity = "0";
      } else {
        headerBg.style.display = "block";
        headerBg.style.opacity = "0";
        setTimeout(() => {
          headerBg.style.opacity = "1";
        }, 300);
      }
    }
  };

  menuToggle.addEventListener("click", toggleMenu);

  window.addEventListener("resize", () => {
    if (window.innerWidth > 767) {
      document.body.classList.remove("mobile-menu-open");
      document.documentElement.classList.remove("mobile-menu-open");
    }

    if (document.body.classList.contains("mobile-menu-open")) {
      setMobileMenuViewportHeight();
    }
  });

  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", () => {
      if (document.body.classList.contains("mobile-menu-open")) {
        setMobileMenuViewportHeight();
      }
    });
  }

  document.querySelectorAll(".header__link").forEach((link) => {
    if (link.hasAttribute("data-speakers-trigger")) return;
    link.addEventListener("click", () => {
      if (document.querySelector(".menu__open").style.display === "none") {
        toggleMenu();
      }
    });
  });
}

// Hero scroll handler (sticky bottom bar)
function initHeroScrollHandler() {
  const heroBottom = document.querySelector(".hero__bottom");
  const featuresSection = document.getElementById("features");
  const footerSection = document.getElementById("footer");

  if (!heroBottom || !featuresSection) return;

  let featuresTriggerY = 0;
  let footerTriggerY = Number.POSITIVE_INFINITY;
  let currentState = "";
  let ticking = false;

  const getDocumentTop = (element) => {
    const rect = element.getBoundingClientRect();
    return rect.top + (window.scrollY || window.pageYOffset || 0);
  };

  const recalcThresholds = () => {
    const viewportHeight = window.innerHeight || 0;
    featuresTriggerY = Math.max(
      0,
      getDocumentTop(featuresSection) - viewportHeight,
    );

    if (footerSection) {
      footerTriggerY = Math.max(
        0,
        getDocumentTop(footerSection) - viewportHeight,
      );
    } else {
      footerTriggerY = Number.POSITIVE_INFINITY;
    }
  };

  const applyState = (nextState) => {
    if (currentState === nextState) return;
    currentState = nextState;

    if (nextState === "hidden") {
      heroBottom.style.bottom = "-100%";
      return;
    }

    if (nextState === "visible") {
      heroBottom.style.bottom = "0%";
      return;
    }

    heroBottom.style.bottom = "";
  };

  const update = () => {
    const scrollY = window.scrollY || window.pageYOffset || 0;

    if (scrollY >= footerTriggerY) {
      applyState("hidden");
    } else if (scrollY >= featuresTriggerY) {
      applyState("visible");
    } else {
      applyState("default");
    }
  };

  const scheduleUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  };

  recalcThresholds();
  update();

  window.addEventListener("scroll", scheduleUpdate, { passive: true });
  window.addEventListener("load", () => {
    recalcThresholds();
    update();
  });
  onViewportWidthChange(() => {
    recalcThresholds();
    update();
  });
}

// Header scroll behavior - DISABLED (header no longer sticky)
/*
function initHeaderScroll() {
  const header =
    document
      .querySelector("header.header")
      ?.closest('[id^="shopify-section"]') ||
    document.querySelector('[id*="__header"]') ||
    document.querySelector("header.header");

  if (!header) return;

  if (window.innerWidth <= 767) {
    return;
  }

  let lastScroll = 0;
  let ticking = false;

  header.style.willChange = "transform";

  function updateHeader() {
    const currentScroll = window.pageYOffset;

    if (currentScroll > lastScroll && currentScroll > 100) {
      header.style.transform = "translateY(-100%)";
    } else {
      header.style.transform = "translateY(0)";
    }

    lastScroll = currentScroll;
    ticking = false;
  }

  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    },
    { passive: true }
  );
}
*/

function initSpeakersMenu() {
  const container = document.querySelector("[data-speakers]");
  const trigger = container?.querySelector("[data-speakers-trigger]");
  const overlay = document.querySelector("[data-speakers-overlay]");
  const panel = document.querySelector("[data-speakers-panel]");
  const headerEl = document.querySelector("header.header");
  const mobilePanel = document.querySelector("[data-speakers-mobile]");
  const linksWrap = document.querySelector(".links__wrap");
  const body = document.body;

  if (!container || !trigger || !overlay || !panel || !headerEl) return;

  const isMobile = () => window.innerWidth < 768;

  const setHeaderHeightVar = () => {
    const height = headerEl.offsetHeight || 0;
    document.documentElement.style.setProperty(
      "--header-height",
      `${height}px`,
    );
  };

  setHeaderHeightVar();

  let hideTimer;
  let mobileHideTimer;
  let overlayHideTimer;

  const openMobilePanel = () => {
    if (!mobilePanel) return;
    mobilePanel.classList.remove("is-hiding-up");
    mobilePanel.classList.add("is-visible");
    mobilePanel.setAttribute("aria-hidden", "false");
    linksWrap?.classList.add("speakers-mobile-open");
  };

  const closeMobilePanel = ({ hideUp = false } = {}) => {
    if (!mobilePanel) return;
    clearTimeout(mobileHideTimer);
    if (hideUp) {
      mobilePanel.classList.add("is-hiding-up");
      mobileHideTimer = setTimeout(() => {
        mobilePanel.classList.remove("is-visible");
        mobilePanel.setAttribute("aria-hidden", "true");
        mobilePanel.classList.remove("is-hiding-up");
      }, 220);
    } else {
      mobilePanel.classList.remove("is-visible");
      mobilePanel.setAttribute("aria-hidden", "true");
      mobilePanel.classList.remove("is-hiding-up");
    }
    linksWrap?.classList.remove("speakers-mobile-open");
  };

  const open = () => {
    clearTimeout(hideTimer);
    clearTimeout(overlayHideTimer);
    setHeaderHeightVar();
    container.classList.add("is-open");
    if (isMobile()) {
      openMobilePanel();
    } else {
      overlay.style.display = "block";
      overlay.classList.remove("is-visible");
      overlay.setAttribute("aria-hidden", "false");
      panel.setAttribute("aria-hidden", "false");
      requestAnimationFrame(() => {
        overlay.classList.add("is-visible");
      });
    }
    trigger.setAttribute("aria-expanded", "true");
    body.classList.add("header-speakers-open");
  };

  const close = ({ hideUp = false } = {}) => {
    clearTimeout(hideTimer);
    container.classList.remove("is-open");
    if (isMobile()) {
      closeMobilePanel({ hideUp });
    } else {
      overlay.classList.remove("is-visible");
      overlay.setAttribute("aria-hidden", "true");
      panel.setAttribute("aria-hidden", "true");
      clearTimeout(overlayHideTimer);
      overlayHideTimer = setTimeout(() => {
        overlay.style.display = "none";
      }, DESKTOP_SPEAKERS_TRANSITION_MS);
    }
    trigger.setAttribute("aria-expanded", "false");
    body.classList.remove("header-speakers-open");
  };

  const clearScheduledClose = () => {
    clearTimeout(hideTimer);
  };

  const isWithinSpeakersMenu = (node) => {
    if (!(node instanceof Node)) return false;
    return (
      container.contains(node) || panel.contains(node) || overlay.contains(node)
    );
  };

  const scheduleClose = (nextTarget = null) => {
    if (isMobile()) return;
    if (isWithinSpeakersMenu(nextTarget)) {
      clearScheduledClose();
      return;
    }
    hideTimer = setTimeout(() => {
      if (
        container.matches(":hover") ||
        trigger.matches(":hover") ||
        panel.matches(":hover") ||
        overlay.matches(":hover")
      ) {
        return;
      }
      close();
    }, 300);
  };

  trigger.addEventListener("mouseenter", () => {
    if (!isMobile()) open();
  });
  container.addEventListener("mouseenter", () => {
    if (!isMobile()) open();
  });
  container.addEventListener("mouseleave", (event) => {
    if (!isMobile()) scheduleClose(event.relatedTarget);
  });
  trigger.addEventListener("focus", () => {
    if (!isMobile()) open();
  });
  trigger.addEventListener("blur", (event) => {
    if (isMobile()) return;
    if (panel.contains(event.relatedTarget)) return;
    scheduleClose(event.relatedTarget);
  });

  panel.addEventListener("mouseenter", () => {
    if (!isMobile()) {
      clearScheduledClose();
    }
  });
  panel.addEventListener("mouseleave", (event) => {
    if (!isMobile()) scheduleClose(event.relatedTarget);
  });
  panel.addEventListener("focusin", () => {
    if (!isMobile()) {
      clearScheduledClose();
      open();
    }
  });
  panel.addEventListener("focusout", (event) => {
    if (isMobile()) return;
    if (
      panel.contains(event.relatedTarget) ||
      container.contains(event.relatedTarget)
    ) {
      return;
    }
    scheduleClose(event.relatedTarget);
  });

  overlay.addEventListener("mouseenter", () => {
    if (!isMobile()) {
      clearScheduledClose();
    }
  });

  overlay.addEventListener("mouseleave", (event) => {
    if (!isMobile()) scheduleClose(event.relatedTarget);
  });

  overlay.addEventListener("click", (event) => {
    if (event.target === overlay) {
      close();
    }
  });

  trigger.addEventListener("click", (event) => {
    if (!isMobile()) return;
    event.preventDefault();
    if (container.classList.contains("is-open")) {
      close();
    } else {
      open();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      close();
    }
  });

  onViewportWidthChange(() => {
    setHeaderHeightVar();
    close();
  });

  document.addEventListener("speakers:close", (event) => {
    close(event?.detail || {});
  });
}

function initSpeakersSlider() {
  const slider = document.querySelector(
    ".header__speakers-panel .header-speakers__cards",
  );
  if (!slider) return;

  const isDesktop = () => window.innerWidth >= 768;
  const DRAG_THRESHOLD = 5;

  let isDown = false;
  let startX = 0;
  let startScroll = 0;
  let moved = false;
  let didDrag = false;

  const onMouseDown = (e) => {
    if (!isDesktop()) return;
    if (e.button !== 0) return;
    isDown = true;
    moved = false;
    didDrag = false;
    startX = e.clientX;
    startScroll = slider.scrollLeft;
  };

  const onMouseMove = (e) => {
    if (!isDown) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > DRAG_THRESHOLD) {
      moved = true;
      didDrag = true;
      slider.classList.add("is-dragging");
    }
    if (!moved) return;
    e.preventDefault();
    slider.scrollLeft = startScroll - dx;
  };

  const onMouseUp = () => {
    if (!isDown) return;
    isDown = false;
    slider.classList.remove("is-dragging");
  };

  slider.addEventListener("mousedown", onMouseDown);
  document.addEventListener("mousemove", onMouseMove);
  document.addEventListener("mouseup", onMouseUp);

  slider.addEventListener(
    "click",
    (e) => {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
        didDrag = false;
      }
    },
    true,
  );

  slider.addEventListener("dragstart", (e) => e.preventDefault());

  slider.addEventListener(
    "wheel",
    (e) => {
      if (!isDesktop()) return;
      const absY = Math.abs(e.deltaY);
      const absX = Math.abs(e.deltaX);
      const delta = absY > absX ? e.deltaY : e.deltaX;
      if (delta === 0) return;
      const max = slider.scrollWidth - slider.clientWidth;
      const next = slider.scrollLeft + delta;
      if (
        (delta < 0 && slider.scrollLeft > 0) ||
        (delta > 0 && slider.scrollLeft < max)
      ) {
        e.preventDefault();
        slider.scrollLeft = Math.max(0, Math.min(max, next));
      }
    },
    { passive: false },
  );
}

function initCartItemsDragScroll() {
  const slider = document.querySelector(
    ".product-template-midi-football .hero__bottom .cart__items, .product-template-lite .hero__bottom .cart__items, .product-template-lite-plus .hero__bottom .cart__items, .product-template-lite-plus-2 .hero__bottom .cart__items",
  );
  if (!slider) return;

  const isDesktop = () => window.innerWidth >= 768;
  const DRAG_THRESHOLD = 10;

  let isDown = false;
  let startX = 0;
  let startScroll = 0;
  let moved = false;
  let didDrag = false;

  const onMouseDown = (e) => {
    if (!isDesktop()) return;
    if (e.button !== 0) return;
    isDown = true;
    moved = false;
    didDrag = false;
    startX = e.clientX;
    startScroll = slider.scrollLeft;
  };

  const onMouseMove = (e) => {
    if (!isDown) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > DRAG_THRESHOLD) {
      moved = true;
      didDrag = true;
      slider.classList.add("is-dragging");
    }
    if (!moved) return;
    e.preventDefault();
    slider.scrollLeft = startScroll - dx;
  };

  const onMouseUp = () => {
    if (!isDown) return;
    isDown = false;
    slider.classList.remove("is-dragging");
  };

  slider.addEventListener("mousedown", onMouseDown);
  document.addEventListener("mousemove", onMouseMove);
  document.addEventListener("mouseup", onMouseUp);

  slider.addEventListener(
    "click",
    (e) => {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
        didDrag = false;
      }
    },
    true,
  );

  slider.addEventListener("dragstart", (e) => e.preventDefault());
}

function initQuickAddButtons() {
  document.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-quick-add]");
    if (!button || button.disabled) return;

    const variantId = button.getAttribute("data-variant-id");
    if (!variantId) return;

    event.preventDefault();
    await quickAddToCart(button, variantId);
  });
}

async function quickAddToCart(button, variantId) {
  toggleQuickAddState(button, true);

  const cartDrawer = document.querySelector("cart-drawer");

  const config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  delete config.headers["Content-Type"];

  const formData = new FormData();
  formData.append("id", variantId);
  formData.append("quantity", button.getAttribute("data-quantity") || 1);

  if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
    try {
      formData.append(
        "sections",
        cartDrawer
          .getSectionsToRender()
          .map((section) => section.id)
          .join(","),
      );
      formData.append("sections_url", window.location.pathname);
    } catch (error) {}
  }

  config.body = formData;

  try {
    const response = await fetch(window.routes.cart_add_url, config);
    const data = await response.json();

    if (data.status) {
      handleQuickAddError(data, button);
      return;
    }

    if (cartDrawer) {
      if (typeof publish === "function" && PUBSUB_EVENTS) {
        publish(PUBSUB_EVENTS.cartUpdate, {
          source: "quick-add",
          productVariantId: variantId,
          cartData: data,
        });
      }
      cartDrawer.renderContents(data);
    } else {
      await updateCartCountBadge();
    }

    document.dispatchEvent(new CustomEvent("cart:updated", { detail: data }));
  } catch (error) {
    handleQuickAddError(error, button);
  } finally {
    toggleQuickAddState(button, false);
  }
}

async function updateCartCountBadge() {
  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();
    const countEls = document.querySelectorAll("[data-cart-count]");
    countEls.forEach((el) => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? "flex" : "none";
    });
  } catch (error) {
    console.warn("Failed to refresh cart count", error);
  }
}

function toggleQuickAddState(button, isLoading) {
  const label = button.querySelector(
    ".home-hero__button-label, .header-speaker-card__button-label",
  );
  if (isLoading) {
    button.dataset.originalText = label?.textContent || button.textContent;
    if (label) {
      label.textContent = "Adding...";
    } else {
      button.textContent = "Adding...";
    }
    button.classList.add("is-loading");
    button.disabled = true;
    button.setAttribute("aria-disabled", "true");
  } else {
    const original = button.dataset.originalText;
    if (original) {
      if (label) {
        label.textContent = original;
      } else {
        button.textContent = original;
      }
    }
    button.classList.remove("is-loading");
    button.disabled = false;
    button.removeAttribute("aria-disabled");
  }
}

function handleQuickAddError(error, button) {
  const message =
    error?.description ||
    error?.message ||
    "Unable to add this speaker to cart right now.";
  if (window.NotificationManager) {
    window.NotificationManager.error(message);
  } else {
    console.error(message);
    alert(message);
  }
}

const PREORDER_MAX_QTY = 9999;
const IS_LITE_PRODUCT_TEMPLATE =
  document.body?.classList.contains("product-template-lite") ||
  document.body?.classList.contains("product-template-lite-plus") ||
  document.body?.classList.contains("product-template-lite-plus-2") ||
  false;

function getVariantStateFromElement(variantEl) {
  if (!variantEl) {
    return {
      isAvailable: false,
      inventoryQty: 0,
      inventoryPolicy: "deny",
      isPreorder: false,
    };
  }

  const isAvailable =
    variantEl.getAttribute("data-variant-available") === "true";
  const inventoryQty =
    parseInt(variantEl.getAttribute("data-variant-inventory")) || 0;
  const inventoryPolicy = (
    variantEl.getAttribute("data-variant-inventory-policy") || "deny"
  ).toLowerCase();
  const isPreorder =
    IS_LITE_PRODUCT_TEMPLATE &&
    isAvailable &&
    inventoryPolicy === "continue" &&
    inventoryQty <= 0;

  return { isAvailable, inventoryQty, inventoryPolicy, isPreorder };
}

function getSelectedVariantElement() {
  const hiddenInput = document.querySelector("input[data-variant-id]");
  const selectedVariantId = hiddenInput?.value;
  if (selectedVariantId) {
    return document.querySelector(
      `[data-variant-id="${selectedVariantId}"]:not([name])`,
    );
  }
  return document.querySelector("[data-variant-id].is-active:not([name])");
}

function getSelectedVariantState() {
  return getVariantStateFromElement(getSelectedVariantElement());
}

function setButtonTextPreservingIcon(button, text) {
  const label = button.querySelector(
    ".home-hero__button-label, .header-speaker-card__button-label",
  );
  if (label) {
    label.textContent = text;
    return;
  }

  const textNode = Array.from(button.childNodes).find(
    (node) => node.nodeType === Node.TEXT_NODE,
  );
  if (textNode) {
    textNode.textContent = ` ${text} `;
    return;
  }

  button.prepend(document.createTextNode(`${text} `));
}

function updateLiteCtaLabels(isPreorder) {
  if (!IS_LITE_PRODUCT_TEMPLATE) return;

  const buttons = document.querySelectorAll(
    ".cart__add[data-add-to-cart], .cart__add[data-add-to-cart-sticky]",
  );

  buttons.forEach((button) => {
    const isSticky = button.hasAttribute("data-add-to-cart-sticky");
    const defaultLabel =
      button.getAttribute("data-default-label") ||
      (isSticky ? "Add" : "Add to Cart");
    const preorderLabel =
      button.getAttribute("data-preorder-label") ||
      (isSticky ? "Pre-order" : "Pre-order now");
    const nextLabel = isPreorder ? preorderLabel : defaultLabel;

    if (button.getAttribute("data-lite-preorder-trigger") === "true") {
      button.setAttribute(
        "data-lite-preorder-active",
        isPreorder ? "true" : "false",
      );
    }
    button.dataset.currentText = nextLabel;
    setButtonTextPreservingIcon(button, nextLabel);
  });
}

function updateLiteQuestionsPrefix(isPreorder) {
  if (!IS_LITE_PRODUCT_TEMPLATE) return;

  const prefixEl = document.querySelector("[data-lite-buy-prefix]");
  if (!prefixEl) return;

  const defaultLabel =
    prefixEl.getAttribute("data-default-label") || prefixEl.textContent.trim();
  const preorderLabel =
    prefixEl.getAttribute("data-preorder-label") || "Pre-order now for";

  prefixEl.textContent = isPreorder ? preorderLabel : defaultLabel;
}

function updateLitePreorderUi(isPreorder) {
  updateLiteCtaLabels(isPreorder);
  updateLiteQuestionsPrefix(isPreorder);
}

const LITE_PREORDER_MODAL_SELECTOR = "[data-lite-preorder-modal]";
const LITE_PREORDER_TRIGGER_SELECTOR = '[data-lite-preorder-trigger="true"]';
const LITE_PREORDER_ACTIVE_SELECTOR =
  '[data-lite-preorder-trigger="true"][data-lite-preorder-active="true"]';
const LITE_PREORDER_MODAL_OPEN_CLASS = "lite-preorder-modal-open";

let litePreorderModalEl = null;
let litePreorderModalResolve = null;
let litePreorderModalLastFocus = null;

function isLitePreorderModalOpen() {
  return (
    !!litePreorderModalEl &&
    litePreorderModalEl.classList.contains("is-visible")
  );
}

function ensureLitePreorderModal() {
  if (litePreorderModalEl && document.body.contains(litePreorderModalEl)) {
    return litePreorderModalEl;
  }

  litePreorderModalEl = document.querySelector(LITE_PREORDER_MODAL_SELECTOR);
  if (litePreorderModalEl) {
    return litePreorderModalEl;
  }

  const modal = document.createElement("div");
  modal.className = "lite-preorder-modal";
  modal.setAttribute("data-lite-preorder-modal", "");
  modal.setAttribute("aria-hidden", "true");
  modal.setAttribute("hidden", "");

  modal.innerHTML = `
    <button type="button" class="lite-preorder-modal__backdrop" aria-label="Close popup" data-lite-preorder-close></button>
    <div class="lite-preorder-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="lite-preorder-modal-title">
      <div class="lite-preorder-modal__media" role="img" aria-label="Yasmina Lite pre-order" style="--bg-desk: url('${window.storeConfig.cdnBase}lite-preorder.webp')"></div>
      <div class="lite-preorder-modal__content">
        <div class="lite-preorder-modal__text-wrap">
          <h2 id="lite-preorder-modal-title" class="lite-preorder-modal__title">You are placing a&nbsp;preorder on&nbsp;Yasmina Lite</h2>
          <p class="lite-preorder-modal__text">
            Item will be in stock starting <span style="white-space: nowrap">from&nbsp;<span class="lite-preorder-modal__tag">16th of July</span></span>
          </p>
        </div>
        <div class="lite-preorder-modal__footer">
          <div class="lite-preorder-modal__actions">
            <button type="button" class="lite-preorder-modal__button lite-preorder-modal__button--decline" data-lite-preorder-close>Decline</button>
            <button type="button" class="lite-preorder-modal__button lite-preorder-modal__button--confirm" data-lite-preorder-confirm>Confirm</button>
          </div>
          <p class="lite-preorder-modal__disclaimer">Than it takes 3-5 business days for the delivery. Thank you for&nbsp;your&nbsp;patience and&nbsp;understanding.</p>
        </div>
      </div>
      <button type="button" class="lite-preorder-modal__close" aria-label="Close popup" data-lite-preorder-close>
        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.75 6.58374L6.58363 0.750109" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M0.75 0.750244L6.58363 6.58387" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  `;

  document.body.appendChild(modal);
  litePreorderModalEl = modal;
  return modal;
}

function cleanupLitePreorderModal() {
  if (!litePreorderModalEl) return;
  litePreorderModalEl.classList.remove("is-visible");
  litePreorderModalEl.setAttribute("aria-hidden", "true");
  litePreorderModalEl.setAttribute("hidden", "");
  document.body.classList.remove(LITE_PREORDER_MODAL_OPEN_CLASS);
  document.removeEventListener("keydown", handleLitePreorderModalEsc);

  if (
    litePreorderModalLastFocus &&
    typeof litePreorderModalLastFocus.focus === "function"
  ) {
    try {
      litePreorderModalLastFocus.focus({ preventScroll: true });
    } catch (error) {}
  }
  litePreorderModalLastFocus = null;
}

function resolveLitePreorderModal(result) {
  cleanupLitePreorderModal();
  if (!litePreorderModalResolve) return;
  const resolve = litePreorderModalResolve;
  litePreorderModalResolve = null;
  resolve(!!result);
}

function handleLitePreorderModalEsc(event) {
  if (event.key !== "Escape") return;
  if (!isLitePreorderModalOpen()) return;
  resolveLitePreorderModal(false);
}

function openLitePreorderModal() {
  const modal = ensureLitePreorderModal();
  if (!modal || isLitePreorderModalOpen() || litePreorderModalResolve) {
    return Promise.resolve(false);
  }

  modal.querySelectorAll("[data-lite-preorder-close]").forEach((button) => {
    button.onclick = () => resolveLitePreorderModal(false);
  });

  const confirmButton = modal.querySelector("[data-lite-preorder-confirm]");
  if (confirmButton) {
    confirmButton.onclick = () => resolveLitePreorderModal(true);
  }

  litePreorderModalLastFocus =
    document.activeElement instanceof HTMLElement
      ? document.activeElement
      : null;

  modal.removeAttribute("hidden");
  modal.setAttribute("aria-hidden", "false");
  document.body.classList.add(LITE_PREORDER_MODAL_OPEN_CLASS);

  requestAnimationFrame(() => {
    modal.classList.add("is-visible");
  });

  document.addEventListener("keydown", handleLitePreorderModalEsc);

  if (confirmButton && typeof confirmButton.focus === "function") {
    try {
      confirmButton.focus({ preventScroll: true });
    } catch (error) {}
  }

  return new Promise((resolve) => {
    litePreorderModalResolve = resolve;
  });
}

function shouldOpenLitePreorderModal(context = {}) {
  const submitButton = context.submitButton;
  const form = context.form;

  if (
    submitButton &&
    submitButton.matches(LITE_PREORDER_TRIGGER_SELECTOR) &&
    submitButton.getAttribute("data-lite-preorder-active") === "true"
  ) {
    return true;
  }

  if (form && form.querySelector(LITE_PREORDER_ACTIVE_SELECTOR)) {
    return true;
  }

  return (
    (document.body.classList.contains("product-template-lite") ||
      document.body.classList.contains("product-template-lite-plus") ||
      document.body.classList.contains("product-template-lite-plus-2")) &&
    !!document.querySelector(
      `[data-add-to-cart-sticky]${LITE_PREORDER_ACTIVE_SELECTOR}`,
    )
  );
}

window.YasminaLitePreorderModal = {
  shouldOpen: shouldOpenLitePreorderModal,
  confirmIfNeeded(context = {}) {
    if (!shouldOpenLitePreorderModal(context)) {
      return Promise.resolve(true);
    }
    return openLitePreorderModal();
  },
};

const LITE_TERMS_MODAL_SELECTOR = "[data-lite-terms-modal]";
const LITE_TERMS_TRIGGER_SELECTOR = "[data-lite-terms-open]";
const LITE_TERMS_CLOSE_SELECTOR = "[data-lite-terms-close]";
const LITE_TERMS_MODAL_OPEN_CLASS = "lite-terms-modal-open";

function initLiteTermsModal() {
  if (!IS_LITE_PRODUCT_TEMPLATE) return;

  const modal = document.querySelector(LITE_TERMS_MODAL_SELECTOR);
  if (!modal) return;

  const triggers = document.querySelectorAll(LITE_TERMS_TRIGGER_SELECTOR);
  if (!triggers.length) return;

  const closeButtons = modal.querySelectorAll(LITE_TERMS_CLOSE_SELECTOR);
  const scrollableContent = modal.querySelector("[data-lite-terms-scroll]");
  const closeButton = modal.querySelector(".lite-terms-modal__close");
  let isOpen = false;
  let lastFocusedElement = null;

  const onKeydown = (event) => {
    if (event.key !== "Escape") return;
    closeModal();
  };

  function closeModal() {
    if (!isOpen) return;
    isOpen = false;
    modal.classList.remove("is-visible");
    modal.setAttribute("aria-hidden", "true");
    modal.setAttribute("hidden", "");
    document.body.classList.remove(LITE_TERMS_MODAL_OPEN_CLASS);
    document.removeEventListener("keydown", onKeydown);

    if (lastFocusedElement && typeof lastFocusedElement.focus === "function") {
      try {
        lastFocusedElement.focus({ preventScroll: true });
      } catch (error) {}
    }
    lastFocusedElement = null;
  }

  function openModal() {
    if (isOpen) return;
    isOpen = true;
    lastFocusedElement =
      document.activeElement instanceof HTMLElement
        ? document.activeElement
        : null;

    modal.removeAttribute("hidden");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add(LITE_TERMS_MODAL_OPEN_CLASS);

    if (scrollableContent) {
      scrollableContent.scrollTop = 0;
    }

    requestAnimationFrame(() => {
      modal.classList.add("is-visible");
    });

    document.addEventListener("keydown", onKeydown);

    if (closeButton && typeof closeButton.focus === "function") {
      try {
        closeButton.focus({ preventScroll: true });
      } catch (error) {}
    }
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      openModal();
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", closeModal);
  });
}

const DELAY_NOTICE_MODAL_SELECTOR = "[data-delay-notice-modal]";
const DELAY_NOTICE_CLOSE_SELECTOR = "[data-delay-notice-close]";
const DELAY_NOTICE_MODAL_OPEN_CLASS = "delay-notice-modal-open";
const DELAY_NOTICE_MODAL_DELAY_MS = 3000;
const DELAY_NOTICE_MODAL_CLOSED_EVENT = "yasmina:delay-notice-closed";
const DELAY_NOTICE_MODAL_READY_EVENT = "yasmina:delay-notice-ready";
const GUARANTEE_MODAL_SELECTOR = "[data-guarantee-modal]";
const GUARANTEE_MODAL_CLOSE_SELECTOR = "[data-guarantee-modal-close]";
const GUARANTEE_MODAL_OPEN_CLASS = "guarantee-modal-open";

let delayNoticeModalEl = null;
let delayNoticeModalTimerId = null;
let delayNoticeModalIsOpen = false;
let guaranteeModalEl = null;
let guaranteeModalIsOpen = false;

if (typeof window !== "undefined") {
  window.YasminaDelayNoticeModalState = window.YasminaDelayNoticeModalState || {
    isEnabled: false,
    hasClosed: false,
  };
}

function isDelayNoticeTargetPage() {
  if (!document.body) return false;

  const body = document.body;
  if (
    body.classList.contains("template-product") ||
    body.classList.contains("template-index") ||
    body.classList.contains("template-list-collections") ||
    body.classList.contains("template-collection")
  ) {
    return true;
  }

  const normalizedPath = normalizePathname(window.location.pathname || "/");
  return (
    normalizedPath === "/collections" ||
    normalizedPath.startsWith("/collections/")
  );
}

function updateDelayNoticeModalThemeClass(modal) {
  if (!modal || !document.body) return;
  modal.classList.toggle(
    "delay-notice-modal--max",
    document.body.classList.contains("product-template-max"),
  );
}

function ensureDelayNoticeModal() {
  if (delayNoticeModalEl && document.body.contains(delayNoticeModalEl)) {
    updateDelayNoticeModalThemeClass(delayNoticeModalEl);
    return delayNoticeModalEl;
  }

  delayNoticeModalEl = document.querySelector(DELAY_NOTICE_MODAL_SELECTOR);
  if (delayNoticeModalEl) {
    updateDelayNoticeModalThemeClass(delayNoticeModalEl);
    return delayNoticeModalEl;
  }

  const modal = document.createElement("div");
  modal.className = "delay-notice-modal";
  modal.setAttribute("data-delay-notice-modal", "");
  modal.setAttribute("aria-hidden", "true");
  modal.setAttribute("hidden", "");

  modal.innerHTML = `
    <button type="button" class="delay-notice-modal__backdrop" aria-label="Close popup" data-delay-notice-close></button>
    <div class="delay-notice-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="delay-notice-modal-title">
      <div class="delay-notice-modal__media" role="img" aria-label="Delivery update"></div>
      <div class="delay-notice-modal__content">
        <div class="delay-notice-modal__text-wrap">
          <h2 id="delay-notice-modal-title" class="delay-notice-modal__title">Dear customers</h2>
          <p class="delay-notice-modal__text">Due to the current situation in&nbsp;the&nbsp;region, some deliveries may take longer than usual. We are doing everything possible to get your orders to you as&nbsp;quickly as&nbsp;we&nbsp;can, while making sure our&nbsp;team and partners stay safe. We truly appreciate your patience and understanding.</p>
        </div>
      </div>
      <button type="button" class="delay-notice-modal__close" aria-label="Close popup" data-delay-notice-close>
        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.75 6.58374L6.58363 0.750109" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M0.75 0.750244L6.58363 6.58387" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  `;

  modal.querySelectorAll(DELAY_NOTICE_CLOSE_SELECTOR).forEach((button) => {
    button.addEventListener("click", closeDelayNoticeModal);
  });

  document.body.appendChild(modal);
  delayNoticeModalEl = modal;
  updateDelayNoticeModalThemeClass(delayNoticeModalEl);
  return delayNoticeModalEl;
}

function clearDelayNoticeModalTimer() {
  if (!delayNoticeModalTimerId) return;
  window.clearTimeout(delayNoticeModalTimerId);
  delayNoticeModalTimerId = null;
}

function handleDelayNoticeModalEsc(event) {
  if (event.key !== "Escape") return;
  closeDelayNoticeModal();
}

function closeDelayNoticeModal() {
  if (!delayNoticeModalEl || !delayNoticeModalIsOpen) return;
  delayNoticeModalIsOpen = false;
  delayNoticeModalEl.classList.remove("is-visible");
  delayNoticeModalEl.setAttribute("aria-hidden", "true");
  delayNoticeModalEl.setAttribute("hidden", "");
  document.body.classList.remove(DELAY_NOTICE_MODAL_OPEN_CLASS);
  document.removeEventListener("keydown", handleDelayNoticeModalEsc);
  if (window.YasminaDelayNoticeModalState) {
    window.YasminaDelayNoticeModalState.hasClosed = true;
  }
  document.dispatchEvent(new CustomEvent(DELAY_NOTICE_MODAL_CLOSED_EVENT));
}

function openDelayNoticeModal() {
  if (!isDelayNoticeTargetPage() || delayNoticeModalIsOpen) return;

  clearDelayNoticeModalTimer();

  const modal = ensureDelayNoticeModal();
  if (!modal) return;

  delayNoticeModalIsOpen = true;
  modal.removeAttribute("hidden");
  modal.setAttribute("aria-hidden", "false");
  document.body.classList.add(DELAY_NOTICE_MODAL_OPEN_CLASS);

  requestAnimationFrame(() => {
    modal.classList.add("is-visible");
  });

  document.addEventListener("keydown", handleDelayNoticeModalEsc);
}

function initDelayNoticeModal() {
  if (!isDelayNoticeTargetPage()) {
    if (window.YasminaDelayNoticeModalState) {
      window.YasminaDelayNoticeModalState.isEnabled = false;
      window.YasminaDelayNoticeModalState.hasClosed = true;
    }
    document.dispatchEvent(
      new CustomEvent(DELAY_NOTICE_MODAL_READY_EVENT, {
        detail: { isEnabled: false, hasClosed: true },
      }),
    );
    return;
  }

  if (window.YasminaDelayNoticeModalState) {
    window.YasminaDelayNoticeModalState.isEnabled = true;
    window.YasminaDelayNoticeModalState.hasClosed = false;
  }
  document.dispatchEvent(
    new CustomEvent(DELAY_NOTICE_MODAL_READY_EVENT, {
      detail: { isEnabled: true, hasClosed: false },
    }),
  );

  ensureDelayNoticeModal();

  const elapsedMs =
    typeof performance !== "undefined" &&
    performance &&
    typeof performance.now === "function"
      ? performance.now()
      : 0;
  const timeoutDelay = Math.max(0, DELAY_NOTICE_MODAL_DELAY_MS - elapsedMs);

  clearDelayNoticeModalTimer();
  delayNoticeModalTimerId = window.setTimeout(
    openDelayNoticeModal,
    timeoutDelay,
  );
}

function updateGuaranteeModalThemeClass(modal) {
  if (!modal || !document.body) return;
  modal.classList.toggle(
    "guarantee-modal--max",
    document.body.classList.contains("product-template-max"),
  );
  modal.classList.toggle(
    "guarantee-modal--religion-midi",
    document.body.classList.contains("product-template-religion-midi"),
  );
}

function ensureGuaranteeModal() {
  if (guaranteeModalEl && document.body.contains(guaranteeModalEl)) {
    updateGuaranteeModalThemeClass(guaranteeModalEl);
    return guaranteeModalEl;
  }

  guaranteeModalEl = document.querySelector(GUARANTEE_MODAL_SELECTOR);
  if (guaranteeModalEl) {
    updateGuaranteeModalThemeClass(guaranteeModalEl);
    return guaranteeModalEl;
  }

  const modal = document.createElement("div");
  modal.className = "guarantee-modal";
  modal.setAttribute("data-guarantee-modal", "");
  modal.setAttribute("aria-hidden", "true");
  modal.setAttribute("hidden", "");

  modal.innerHTML = `
    <button type="button" class="guarantee-modal__backdrop" aria-label="Close popup" data-guarantee-modal-close></button>
    <div class="guarantee-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="guarantee-modal-title">
      <div class="guarantee-modal__content">
        <div class="guarantee-modal__text-wrap">
          <h2 id="guarantee-modal-title" class="guarantee-modal__title">How it works</h2>
          <p class="guarantee-modal__text">
            We&rsquo;re so sure in the quality and durability of the Yasmina AI speaker that <strong>we offer you a full extra 1-year guarantee to complement the standard manufacturer&rsquo;s warranty</strong> &mdash; so you&rsquo;re protected for longer. Enjoy crystal-clear sound and smart AI features without worries &mdash; if anything goes wrong, we&rsquo;ve got you covered.
          </p>
        </div>
        <div class="guarantee-modal__details">
          <h3 class="guarantee-modal__details-title">What&rsquo;s included:</h3>
          <ul class="guarantee-modal__list">
            <li>Free repair or replacement for covered issues.</li>
            <li>Hassle-free service &mdash; we make it simple to get your speaker back to perfect condition.</li>
          </ul>
          <p class="guarantee-modal__text guarantee-modal__text--tail">
            Rest assured, your Yasmina AI is designed for reliability and backed by our commitment to quality.
          </p>
        </div>
      </div>
      <button type="button" class="guarantee-modal__close" aria-label="Close popup" data-guarantee-modal-close>
        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.75 6.58374L6.58363 0.750109" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M0.75 0.750244L6.58363 6.58387" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  `;

  modal.querySelectorAll(GUARANTEE_MODAL_CLOSE_SELECTOR).forEach((button) => {
    button.addEventListener("click", closeGuaranteeModal);
  });

  document.body.appendChild(modal);
  guaranteeModalEl = modal;
  updateGuaranteeModalThemeClass(guaranteeModalEl);
  return guaranteeModalEl;
}

function handleGuaranteeModalEsc(event) {
  if (event.key !== "Escape") return;
  closeGuaranteeModal();
}

function closeGuaranteeModal() {
  if (!guaranteeModalEl || !guaranteeModalIsOpen) return;
  guaranteeModalIsOpen = false;
  guaranteeModalEl.classList.remove("is-visible");
  guaranteeModalEl.setAttribute("aria-hidden", "true");
  guaranteeModalEl.setAttribute("hidden", "");
  document.body.classList.remove(GUARANTEE_MODAL_OPEN_CLASS);
  document.removeEventListener("keydown", handleGuaranteeModalEsc);
}

function openGuaranteeModal() {
  if (guaranteeModalIsOpen) return;

  const modal = ensureGuaranteeModal();
  if (!modal) return;

  guaranteeModalIsOpen = true;
  updateGuaranteeModalThemeClass(modal);
  modal.removeAttribute("hidden");
  modal.setAttribute("aria-hidden", "false");
  document.body.classList.add(GUARANTEE_MODAL_OPEN_CLASS);

  requestAnimationFrame(() => {
    modal.classList.add("is-visible");
  });

  document.addEventListener("keydown", handleGuaranteeModalEsc);
}

window.YasminaGuaranteeModal = {
  open: openGuaranteeModal,
  close: closeGuaranteeModal,
};

function isVariantPurchasable(isAvailable, inventoryQty, isPreorder = false) {
  if (isPreorder) return true;
  if (!isAvailable) return false;
  return inventoryQty > 0;
}

function getVariantMaxQuantity(isAvailable, inventoryQty, isPreorder = false) {
  if (!isVariantPurchasable(isAvailable, inventoryQty, isPreorder)) return 0;
  if (inventoryQty > 0) return inventoryQty;
  return isPreorder ? PREORDER_MAX_QTY : 0;
}

function initVariantSelector() {
  const colorItems = document.querySelectorAll("[data-variant-id]:not([name])");

  if (!colorItems.length) return;

  colorItems.forEach((el) => {
    const variantState = getVariantStateFromElement(el);
    if (
      !isVariantPurchasable(
        variantState.isAvailable,
        variantState.inventoryQty,
        variantState.isPreorder,
      )
    ) {
      el.classList.add("is-disabled");
      el.setAttribute("aria-disabled", "true");
    }
  });

  colorItems.forEach((item) => {
    item.addEventListener("click", function (e) {
      const variantId = this.getAttribute("data-variant-id");
      const { isAvailable, inventoryQty, isPreorder } =
        getVariantStateFromElement(this);

      if (
        this.classList.contains("is-disabled") ||
        this.getAttribute("aria-disabled") === "true"
      ) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      if (!isVariantPurchasable(isAvailable, inventoryQty, isPreorder)) {
        e.preventDefault();
        e.stopPropagation();
        this.classList.add("is-disabled");
        this.setAttribute("aria-disabled", "true");
        updateStockStatusDisplay(false, 0);
        setAddToCartEnabled(false);
        return;
      }

      const allVariants = document.querySelectorAll(
        "[data-variant-id]:not([name])",
      );
      allVariants.forEach((v) => v.classList.remove("is-active"));

      const sameVariants = document.querySelectorAll(
        `[data-variant-id="${variantId}"]:not([name])`,
      );
      sameVariants.forEach((v) => v.classList.add("is-active"));

      const hiddenInput = document.querySelector("input[data-variant-id]");
      if (hiddenInput) {
        hiddenInput.value = variantId;
      }

      const quantityInput = document.querySelector("[data-quantity-input]");
      if (quantityInput) {
        const maxQty = getVariantMaxQuantity(
          isAvailable,
          inventoryQty,
          isPreorder,
        );
        quantityInput.setAttribute("max", maxQty);
        quantityInput.setAttribute("data-max", maxQty);
        if (parseInt(quantityInput.value) > maxQty) {
          quantityInput.value = maxQty;
        }

        const counter = quantityInput.closest(".cart__counter");
        if (counter) {
          counter.style.pointerEvents = "";
          counter.style.opacity = "";
        }
      }

      updateStockStatusDisplay(isAvailable, inventoryQty, false, isPreorder);
      syncStockWithQuantity();

      updateVariantPrice(variantId);
    });
  });
}

function updateStockStatusDisplay(
  isAvailable,
  inventoryQty,
  isAllInCart = false,
  isPreorder = false,
) {
  const stockTitles = document.querySelectorAll(".stock__title");
  const stockIcons = document.querySelectorAll(".stock__icon");
  const isPurchasable = isVariantPurchasable(
    isAvailable,
    inventoryQty,
    isPreorder,
  );

  stockTitles.forEach((title) => {
    if (!isPurchasable) {
      if (isAllInCart) {
        title.textContent = "ALL IN CART";
      } else {
        title.textContent = "OUT OF STOCK";
      }
      title.parentElement.classList.add("out-of-stock");
    } else {
      title.textContent = isPreorder ? "PRE-ORDER TODAY" : "IN STOCK";
      title.parentElement.classList.remove("out-of-stock");
    }
  });
  stockIcons.forEach((icon) => {
    if (!isPurchasable) {
      icon.classList.add("out-of-stock");
      icon.style.color = "#dc2626";
    } else {
      icon.classList.remove("out-of-stock");
      icon.style.color = "";
    }
  });

  updateLitePreorderUi(isPurchasable && isPreorder);
}

function updateVariantPrice(variantId) {
  const productForm = document.querySelector("[data-product-form]");
  if (!productForm) return;

  fetch(`${window.location.pathname}?variant=${variantId}`, {
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    },
  })
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const newPriceMain = doc.querySelector(
        ".price__title-span-main:not(.is-bottom)",
      );
      const currentPriceMain = document.querySelector(
        ".price__title-span-main:not(.is-bottom)",
      );

      if (newPriceMain && currentPriceMain) {
        currentPriceMain.textContent = newPriceMain.textContent;
      }

      const newPriceWrap = doc.querySelector(".price__title-wrap");
      const currentPriceWrap = document.querySelector(".price__title-wrap");

      if (newPriceWrap && currentPriceWrap) {
        currentPriceWrap.replaceChildren(
          ...Array.from(newPriceWrap.childNodes).map((node) =>
            node.cloneNode(true),
          ),
        );
      } else if (!newPriceWrap && currentPriceWrap) {
        currentPriceWrap.style.display = "none";
      }

      const newBottomPrice = doc.querySelector(
        ".price__title-span-main.is-bottom",
      );
      const currentBottomPrice = document.querySelector(
        ".price__title-span-main.is-bottom",
      );
      if (newBottomPrice && currentBottomPrice) {
        currentBottomPrice.textContent = newBottomPrice.textContent;
      }

      const newDiscount = doc.querySelector(".price__caption-big");
      const currentDiscounts = document.querySelectorAll(".price__caption-big");
      if (newDiscount && currentDiscounts.length) {
        currentDiscounts.forEach((discountEl) => {
          discountEl.textContent = newDiscount.textContent;
        });
      }
    })
    .catch((error) => {
      console.error("Error updating price:", error);
    });
}

function initQuantityButtons() {
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-quantity-increase]")) {
      e.preventDefault();
      const btn = e.target.closest("[data-quantity-increase]");
      const counter = btn.closest(".cart__counter");
      const input = counter.querySelector("[data-quantity-input]");

      if (input) {
        const currentValue = parseInt(input.value) || 1;
        const max =
          parseInt(input.getAttribute("max")) ||
          parseInt(input.getAttribute("data-max")) ||
          9999;
        const newValue = currentValue + 1;

        if (newValue <= max) {
          input.value = newValue;
        } else {
          input.value = max;
        }
        syncStockWithQuantity();
      }
    }

    if (e.target.closest("[data-quantity-decrease]")) {
      e.preventDefault();
      const btn = e.target.closest("[data-quantity-decrease]");
      const counter = btn.closest(".cart__counter");
      const input = counter.querySelector("[data-quantity-input]");

      if (input) {
        const currentValue = parseInt(input.value) || 1;
        const newValue = Math.max(1, currentValue - 1);
        input.value = newValue;
        syncStockWithQuantity();
      }
    }
  });

  document.addEventListener("input", function (e) {
    if (e.target.matches("[data-quantity-input]")) {
      const input = e.target;
      const value = parseInt(input.value) || 1;
      const min = parseInt(input.getAttribute("min")) || 1;
      const max =
        parseInt(input.getAttribute("max")) ||
        parseInt(input.getAttribute("data-max")) ||
        9999;

      if (value < min) {
        input.value = min;
      } else if (value > max) {
        input.value = max;
      }
      syncStockWithQuantity();
    }
  });
}

function setAddToCartEnabled(enabled) {
  const btns = document.querySelectorAll(
    "[data-add-to-cart], [data-add-to-cart-sticky]",
  );
  btns.forEach((btn) => {
    btn.disabled = !enabled;
    if (!enabled) {
      btn.style.opacity = "0.4";
      btn.style.pointerEvents = "none";
      btn.setAttribute("aria-disabled", "true");
    } else {
      btn.style.opacity = "";
      btn.style.pointerEvents = "";
      btn.removeAttribute("aria-disabled");
    }
  });
}

function syncStockWithQuantity() {
  const input = document.querySelector("[data-quantity-input]");
  if (!input) return;
  const { isPreorder } = getSelectedVariantState();
  const max =
    parseInt(input.getAttribute("max")) ||
    parseInt(input.getAttribute("data-max")) ||
    9999;
  const value = parseInt(input.value) || 1;
  if (value > max) {
    updateStockStatusDisplay(false, 0);
    setAddToCartEnabled(false);
  } else {
    updateStockStatusDisplay(true, max, false, isPreorder);
    setAddToCartEnabled(true);
  }
}

// Main Swiper (Reviews)
function initMainSwiper() {
  const swiperContainer = document.querySelector(".swiper-container");
  if (!swiperContainer) return;

  const swiper = new Swiper(".swiper-container", {
    slidesPerView: "auto",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    on: {
      init: function () {
        updateArrows(this);
      },
      slideChange: function () {
        updateArrows(this);
      },
      reachEnd: function () {
        updateArrows(this);
      },
      reachBeginning: function () {
        updateArrows(this);
      },
    },
  });

  function updateArrows(swiper) {
    const prev = document.querySelector(".swiper-button-prev");
    const next = document.querySelector(".swiper-button-next");
    if (!prev || !next) return;

    if (swiper.isBeginning) {
      prev.style.opacity = "0";
      prev.style.pointerEvents = "none";
    } else {
      prev.style.opacity = "1";
      prev.style.pointerEvents = "auto";
    }

    if (swiper.isEnd) {
      next.style.opacity = "0";
      next.style.pointerEvents = "none";
    } else {
      next.style.opacity = "1";
      next.style.pointerEvents = "auto";
    }
  }
}

// Promocode handler
function initPromocodeHandler() {
  const promocodeIcons = document.querySelectorAll(".promocode__icon");
  promocodeIcons.forEach((icon) => {
    icon.addEventListener("click", function () {
      const promocodeStates = document.querySelectorAll(".promocode__state");
      promocodeStates.forEach((state) => {
        state.classList.add("active");
        setTimeout(() => {
          state.classList.remove("active");
        }, 5000);
      });
      const textToCopy = "ILOVEYASMINA";
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy);
      }
    });
  });
}

// Animated navigation dot
function initAnimatedNavDot() {
  if (window.innerWidth <= 767) return;
  const nav = document.querySelector(".links__wrap");
  const dot = nav?.querySelector(":scope > a .links__circle");
  if (!nav || !dot) return;

  dot.style.cssText += `
    position: absolute;
    display: block;
    transition: all 0.4s cubic-bezier(0.4, 0.0, 0.2, 1);
    opacity: 0;
  `;

  const moveDot = () => {
    const active = document.querySelector(".header__link.w--current");
    if (!active) return;
    if (active.hasAttribute("data-speakers-trigger")) {
      dot.style.opacity = "0";
      return;
    }
    const rect = active.getBoundingClientRect();
    const navRect = nav.getBoundingClientRect();
    dot.style.left = rect.right - navRect.left + 8 + "px";
    dot.style.top = rect.top - navRect.top + rect.height / 2 - 4 + "px";
    dot.style.opacity = "1";
  };

  new MutationObserver(moveDot).observe(nav, {
    subtree: true,
    attributes: true,
    attributeFilter: ["class"],
  });

  setTimeout(moveDot, 100);
}

// Anchor spy with ScrollTrigger
function initAnchorSpyWithScrollTrigger() {
  if (!window.gsap || !window.ScrollTrigger) return;
  if (typeof gsap.registerPlugin === "function")
    gsap.registerPlugin(ScrollTrigger);

  const nav = document.querySelector(".links__wrap");
  if (!nav) return;

  const allLinks = Array.from(nav.querySelectorAll(".header__link"));
  const trackedLinks = [];
  const idToLink = new Map();

  const getAnchorInfo = (link) => {
    const href = link.getAttribute("href");
    if (!href || !href.includes("#")) return null;

    if (href.startsWith("#")) {
      const id = href.slice(1);
      return id ? { id } : null;
    }

    try {
      const url = new URL(href, window.location.origin);
      if (!url.hash) return null;
      if (url.pathname !== window.location.pathname) return null;
      return { id: url.hash.slice(1) };
    } catch (error) {
      return null;
    }
  };

  allLinks.forEach((link) => {
    const info = getAnchorInfo(link);
    if (!info) return;

    const section = document.getElementById(info.id);
    if (!section) return;

    trackedLinks.push(link);
    idToLink.set(info.id, link);
    ScrollTrigger.create({
      trigger: section,
      start: "top 60%",
      end: "bottom 40%",
      onToggle(self) {
        if (!self.isActive) return;
        trackedLinks.forEach((l) => l.classList.remove("w--current"));
        const lnk = idToLink.get(section.id);
        if (lnk) lnk.classList.add("w--current");
      },
    });
  });

  if (!trackedLinks.length) return;

  if (location.hash && idToLink.has(location.hash.slice(1))) {
    trackedLinks.forEach((l) => l.classList.remove("w--current"));
    const cur = idToLink.get(location.hash.slice(1));
    if (cur) cur.classList.add("w--current");
  }

  ScrollTrigger.refresh();
}

// Load more FAQ items
function loadMore() {
  const allFaqItemsList = document.querySelectorAll(".faq__item");
  const showMoreBtn = document.querySelector(".faq__show-more");

  allFaqItemsList.forEach((item, index) => {
    if (index >= 6) {
      item.classList.add("faq__hidden");
    }
  });

  if (showMoreBtn) {
    showMoreBtn.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        const hiddenItemsList = document.querySelectorAll(
          ".faq__item.faq__hidden",
        );
        const showCount = Math.min(3, hiddenItemsList.length);

        for (let i = 0; i < showCount; i++) {
          hiddenItemsList[i].classList.remove("faq__hidden");
        }

        if (hiddenItemsList.length <= 3) {
          this.remove();
        }
      },
      { passive: false },
    );
  }
}

// Open video
function openVideo() {
  const videos = document.querySelectorAll(".feedback__video");
  videos.forEach((v) => {
    v.addEventListener("click", () => {
      if (v.paused) {
        videos.forEach((otherVideo) => {
          if (otherVideo !== v && !otherVideo.paused) {
            otherVideo.pause();
          }
        });
        v.play().catch(() => {});
      } else {
        v.pause();
      }
    });
  });
}

// Metrika - Enhanced tracking with theme selectors
function metrika() {
  if (typeof ym !== "function") {
    console.warn("Yandex.Metrika is not initialized");
    return;
  }

  // Generic goal tracking via data-ym-goal attribute
  document.addEventListener("click", function (e) {
    const el = e.target.closest("[data-ym-goal]");
    if (el) {
      const goal = el.getAttribute("data-ym-goal");
      if (goal) {
        ym(95620399, "reachGoal", goal);
      }
    }
  });

  // Track "Add to Cart" clicks
  document.addEventListener("click", function (e) {
    const addToCartBtn = e.target.closest(
      "[data-add-to-cart], [data-add-to-cart-sticky]",
    );
    if (addToCartBtn && !addToCartBtn.disabled) {
      ym(95620399, "reachGoal", "add_to_cart");
    }
  });

  // Track cart drawer opening
  document.addEventListener("click", function (e) {
    const cartOpenBtn = e.target.closest("[data-cart-open]");
    if (cartOpenBtn) {
      ym(95620399, "reachGoal", "open_cart");
    }
  });

  // Track variant selection
  document.addEventListener("click", function (e) {
    const variantBtn = e.target.closest("[data-variant-id]:not([name])");
    if (variantBtn && !variantBtn.classList.contains("is-disabled")) {
      const variantId = variantBtn.getAttribute("data-variant-id");
      ym(95620399, "reachGoal", "change_variant", {
        variant_id: variantId,
      });
    }
  });

  // Track promocode copy
  document.addEventListener("click", function (e) {
    const promocodeIcon = e.target.closest(".promocode__icon");
    if (promocodeIcon) {
      ym(95620399, "reachGoal", "promocode_copy");
    }
  });

  // Track quantity changes
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-quantity-increase]")) {
      ym(95620399, "reachGoal", "increase_quantity");
    }
    if (e.target.closest("[data-quantity-decrease]")) {
      ym(95620399, "reachGoal", "decrease_quantity");
    }
  });

  // Track checkout button in cart drawer
  document.addEventListener("click", function (e) {
    const checkoutBtn = e.target.closest(
      '[data-cart-drawer] .cart__btn[href*="checkout"]',
    );
    if (checkoutBtn) {
      ym(95620399, "reachGoal", "checkout");
    }
  });

  if (window.PubSub && PUBSUB_EVENTS) {
    window.PubSub.subscribe(PUBSUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === "product-form") {
        ym(95620399, "reachGoal", "add_to_cart_success");
      }
    });
  }
}

// Benefits answer animation
function initBenefitsAnswerAnimation() {
  const wrap = document.querySelector(".benefits__yasmina-answer-wrap");
  const answer = document.querySelector(".benefits__yasmina-answer");
  if (!wrap || !answer) return;

  function getShiftX() {
    const w = wrap.clientWidth || 0;
    return Math.max(100, Math.min(2 * w, 150));
  }

  gsap.set(answer, { x: 0 });

  const mm = gsap.matchMedia();
  mm.add(
    {
      isDesktop: "(min-width: 768px)",
      isMobile: "(max-width: 767px)",
    },
    (ctx) => {
      const { isDesktop } = ctx.conditions;
      const shiftX = getShiftX();

      gsap.to(answer, {
        x: isDesktop ? -shiftX : -shiftX * 0.8,
        ease: "none",
        scrollTrigger: {
          trigger: wrap,
          start: "top 80%",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true,
        },
      });
    },
  );

  onViewportWidthChange(() => ScrollTrigger.refresh());
}

// Reviews decors animation
function initReviewsDecorsAnimation() {
  const section = document.querySelector(".reviews");
  if (!section) return;

  const decors = section.querySelectorAll(".reviews__decor");

  gsap.set(decors, { scale: 0 });

  gsap.to(decors, {
    scale: 1,
    duration: 0.8,
    ease: "back.out(1.7)",
    stagger: { each: 0.2, from: "random" },
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      once: true,
    },
  });
}

// Partners infinite marquee animation
function initPartnersMarquee() {
  if (!window.gsap) return;

  const wrap = document.querySelector(".partners__logos-wrap");
  if (!wrap) return;

  const containers = Array.from(wrap.querySelectorAll(".partners__logos-cont"));
  if (!containers.length) return;

  const originalHTML = wrap.innerHTML;
  wrap.innerHTML = originalHTML + originalHTML;

  function calculateSetWidth() {
    const gap = window.innerWidth > 767 ? 80 : 40;
    let width = 0;
    const currentContainers = Array.from(
      wrap.querySelectorAll(".partners__logos-cont"),
    );
    const half = currentContainers.length / 2;

    for (let i = 0; i < half; i++) {
      width += currentContainers[i].offsetWidth + gap;
    }
    return width;
  }

  let setWidth = calculateSetWidth();

  gsap.set(wrap, { x: 0 });

  let marqueeAnimation = gsap.to(wrap, {
    x: -setWidth,
    duration: 30,
    ease: "linear",
    repeat: -1,
    onRepeat: function () {
      gsap.set(wrap, { x: 0 });
    },
  });

  let resizeTimer;
  onViewportWidthChange(() => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (marqueeAnimation) {
        marqueeAnimation.kill();
      }

      wrap.innerHTML = originalHTML + originalHTML;

      setWidth = calculateSetWidth();

      gsap.set(wrap, { x: 0 });
      marqueeAnimation = gsap.to(wrap, {
        x: -setWidth,
        duration: 30,
        ease: "linear",
        repeat: -1,
        onRepeat: function () {
          gsap.set(wrap, { x: 0 });
        },
      });
    }, 250);
  });
}

async function updateVariantsAvailability(currentCart = null) {
  try {
    if (!currentCart) {
      const cartResponse = await fetch("/cart.js");
      currentCart = await cartResponse.json();
    }

    const variantElements = document.querySelectorAll(
      "[data-variant-id]:not([name])",
    );

    variantElements.forEach((variantEl) => {
      const variantId = variantEl.getAttribute("data-variant-id");
      const {
        isAvailable,
        inventoryQty: maxInventory,
        isPreorder,
      } = getVariantStateFromElement(variantEl);

      if (isPreorder) {
        variantEl.classList.remove("is-disabled");
        variantEl.removeAttribute("aria-disabled");
        return;
      }

      if (maxInventory <= 0) {
        variantEl.classList.add("is-disabled");
        variantEl.setAttribute("aria-disabled", "true");
        return;
      }

      if (!isAvailable) {
        variantEl.classList.add("is-disabled");
        variantEl.setAttribute("aria-disabled", "true");
        return;
      }

      const existingItem = currentCart.items.find(
        (item) => item.variant_id == variantId,
      );
      const qtyInCart = existingItem ? existingItem.quantity : 0;

      if (qtyInCart >= maxInventory) {
        variantEl.classList.add("is-disabled");
        variantEl.setAttribute("aria-disabled", "true");
      } else {
        variantEl.classList.remove("is-disabled");
        variantEl.removeAttribute("aria-disabled");
      }
    });

    const hiddenInput = document.querySelector("input[data-variant-id]");
    if (hiddenInput) {
      const currentVariantId = hiddenInput.value;
      const currentVariantEl = document.querySelector(
        `[data-variant-id="${currentVariantId}"]:not([name])`,
      );

      if (currentVariantEl) {
        const {
          isAvailable,
          inventoryQty: maxInventory,
          isPreorder,
        } = getVariantStateFromElement(currentVariantEl);

        const existingItem = currentCart.items.find(
          (item) => item.variant_id == currentVariantId,
        );
        const qtyInCart = existingItem ? existingItem.quantity : 0;
        const availableToAdd = Math.max(0, maxInventory - qtyInCart);

        const quantityInput = document.querySelector("[data-quantity-input]");
        if (quantityInput) {
          if (!isAvailable && !isPreorder) {
            quantityInput.setAttribute("max", 0);
            quantityInput.setAttribute("data-max", 0);
            quantityInput.value = 1;
            updateStockStatusDisplay(false, 0, false);
            setAddToCartEnabled(false);

            const counter = quantityInput.closest(".cart__counter");
            if (counter) {
              counter.style.pointerEvents = "none";
              counter.style.opacity = "0.4";
            }
          } else if (availableToAdd === 0 && maxInventory > 0) {
            quantityInput.setAttribute("max", 0);
            quantityInput.setAttribute("data-max", 0);
            quantityInput.value = 1;
            updateStockStatusDisplay(false, 0, true);
            setAddToCartEnabled(false);

            const counter = quantityInput.closest(".cart__counter");
            if (counter) {
              counter.style.pointerEvents = "none";
              counter.style.opacity = "0.4";
            }
          } else if (isAvailable && maxInventory > 0) {
            quantityInput.setAttribute("max", availableToAdd);
            quantityInput.setAttribute("data-max", availableToAdd);
            if (parseInt(quantityInput.value) > availableToAdd) {
              quantityInput.value = availableToAdd;
            }
            updateStockStatusDisplay(true, availableToAdd, false);
            setAddToCartEnabled(true);

            const counter = quantityInput.closest(".cart__counter");
            if (counter) {
              counter.style.pointerEvents = "";
              counter.style.opacity = "";
            }
          } else if (isPreorder) {
            quantityInput.setAttribute("max", PREORDER_MAX_QTY);
            quantityInput.setAttribute("data-max", PREORDER_MAX_QTY);
            if ((parseInt(quantityInput.value) || 1) < 1) {
              quantityInput.value = 1;
            }
            updateStockStatusDisplay(true, maxInventory, false, true);
            setAddToCartEnabled(true);

            const counter = quantityInput.closest(".cart__counter");
            if (counter) {
              counter.style.pointerEvents = "";
              counter.style.opacity = "";
            }
          } else {
            quantityInput.setAttribute("max", 0);
            quantityInput.setAttribute("data-max", 0);
            quantityInput.value = 1;
            updateStockStatusDisplay(false, 0, false);
            setAddToCartEnabled(false);

            const counter = quantityInput.closest(".cart__counter");
            if (counter) {
              counter.style.pointerEvents = "none";
              counter.style.opacity = "0.4";
            }
          }
        }
      }
    }
  } catch (error) {
    console.error("Error updating variants availability:", error);
  }
}

window.Shopify = window.Shopify || {};
window.Shopify.routes = window.Shopify.routes || {};
window.Shopify.routes.root = "/";
